// show cart item count
const cartButton = document.querySelector(".js-nav-cart"),
      cartCount = document.querySelector(".js-basket-count");

if (cartButton) {
    const cartItems = parseInt(window.localStorage.getItem("basketItemsNumber"));

    if (cartItems > 0) {
        cartButton.classList.add("c-nav-icon--basket-active");

        if (cartCount) {
            cartCount.classList.add("c-nav-bubble--active");
            cartCount.innerHTML = cartItems;
        }
    }
}